import historyIcon from "../../../../assets/icons/jobcardHistory.svg";

const NoExpenseHistoryView = ({ isSucceed, dataLength }) => {
  let title = "No Expense History Selected";
  let description = "Please select a date range to view your expense history.";

  if (isSucceed && dataLength === 0) {
    title = "No Results Found";
    description =
      "We couldn’t find any expense record for the selected date range";
  }

  return (
    <div className="mt-4 flex justify-center items-center h-full text-gray-800">
      <div className="text-center">
        <img src={historyIcon} alt="No History" className="ml-11 max-lg:w-40" />
        <h4 className="lg:text-2xl pt-3 lg:pt-8 font-figtreeBold">
          {title}
        </h4>
        <p className="text-xs lg:text-lg max-w-sm lg:pt-2">{description}</p>
      </div>
    </div>
  );
};

export default NoExpenseHistoryView;
